"use client";
import useLocale from "./useLocale";
import { useQuery } from "@tanstack/react-query";

const useQueryClient = (options) => {
  const locale = useLocale();
  return useQuery({
    ...options,
    staleTime: 1000 * 60 * 60, // 60 minutes default
    retry: 1,
    refetchOnWindowFocus: false,
    queryKey: [...(options.queryKey || []), locale],
    enabled: options.enabled !== undefined ? options.enabled : true && !!locale,
  });
};
export default useQueryClient;
